const store = window.booqableStore

export const setFilterSearchQuery = (value, key = 'global') => {
  store.dispatch({
    type: 'SET_FILTER_SEARCH_QUERY',
    payload: {
      key,
      value
    }
  })
}

export const setFilterCollection = (value, key = 'global') => {
  store.dispatch({
    type: 'SET_FILTER_COLLECTION',
    payload: {
      key,
      value
    }
  })
}

export const setFilterSortBy = (value, key = 'global') => {
  store.dispatch({
    type: 'SET_FILTER_SORT_BY',
    payload: {
      key,
      value
    }
  })
}

export const setFilterFilterBy = (value, key = 'global') => {
  store.dispatch({
    type: 'SET_FILTER_FILTER_BY',
    payload: {
      key,
      value
    }
  })
}

export default {
  setFilterSearchQuery,
  setFilterSortBy,
  setFilterFilterBy
}
